module.exports = __webpack_public_path__ + "static/media/20171212-_DSC2099_Small.053dde90.jpg";